import { render, staticRenderFns } from "./SCardWorkDebtComp.vue?vue&type=template&id=571a507e&"
import script from "./SCardWorkDebtComp.vue?vue&type=script&lang=js&"
export * from "./SCardWorkDebtComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
